/**
 * <restock-modal>
 *
 * "Notify me when restocked" trigger + modal dialog, rendered by
 * sections/main-product.liquid only when every variant is sold out. The modal
 * wraps a {% form 'customer' %} that tags the subscriber with
 * restock-alert-<product-handle> so the merchant can segment a back-in-stock
 * email per product.
 *
 * Markup contract (scoped to this element):
 *   [data-restock-open]    — trigger button that opens the dialog
 *   [data-restock-dialog]  — the <dialog>
 *   [data-restock-close]   — close button inside the dialog
 *
 * Native <dialog>.showModal() provides the focus trap + Escape handling. The
 * customer form posts with a full page reload; on return Shopify re-renders the
 * success/error message inside the dialog, so we re-open it on load whenever a
 * message is present (keeps the confirmation visible and announced).
 */

class RestockModal extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-restock-open]');
    this.dialog = this.querySelector('[data-restock-dialog]');
    this.closeBtn = this.querySelector('[data-restock-close]');

    if (!this.dialog) return;

    if (this.trigger) this.trigger.addEventListener('click', () => this.open());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.dialog.close());

    // Close on backdrop click (clicks that land on the <dialog> element itself,
    // i.e. outside the inner content).
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => {
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    });

    // Re-open after a form post so the success/error message stays visible.
    if (this.querySelector('.main-product__restock-message-text')) {
      this.open();
    }
  }

  open() {
    if (!this.dialog) return;
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
    if (this.closeBtn) this.closeBtn.focus();
  }
}

if (!customElements.get('restock-modal')) {
  customElements.define('restock-modal', RestockModal);
}
